import { Action, AnyAction, combineReducers } from 'redux'
import storage from 'redux-persist/lib/storage'
import { persistReducer } from 'redux-persist'

import app, { defaultAppState } from './appReducer'
import errors from './errorReducer'
import fileDocuments from './fileDocumentReducer'
import fileParties from './filePartyReducer'
import files from './fileReducer'
import page from './pageReducer'
import parties from './partyReducer'
import users from './userReducer'
import { ThunkAction } from 'redux-thunk'
import { FluxStandardAction } from 'redux-promise-middleware'
import { AppAction } from '../config/appConfig'
import { AxiosPromise, AxiosResponse } from 'axios'

const appReducer = combineReducers({
    app,
    errors,
    fileParties,
    fileDocuments,
    files,
    page,
    parties,
    users,
})

const rootReducer = (state, action) => {
    switch (action.type) {
        case AppAction.LogOut:
            window.location.hash = '/'
            state = {
                app: {
                    ...defaultAppState,
                    version: action.payload || state?.app?.version,
                },
            }
            break
        case AppAction.Reset:
            window.location.hash = '/'
            state = undefined
            break
    }

    return appReducer(state, action)
}

export default persistReducer(
    {
        key: 'root',
        storage,
        whitelist: ['app', 'page'],
    },
    rootReducer,
)

export interface IReduxAction<T = any, M = any> extends FluxStandardAction {
    payload?: T
    meta?: M
}

export interface Dispatch<A extends Action = AnyAction> {
    <T = any>(action: A | Promise<A>): DispatchPromise<T>
    <T extends A>(action: T | Promise<T>): DispatchPromise<T>
    <R, S = null, E = null>(asyncAction: ThunkAction<R, S, E, A>): DispatchPromise<R>
}

export interface DispatchProp<A extends Action = AnyAction> {
    dispatch: Dispatch<A>
}
export type DispatchResponse<T = any, M = any> = {
    action: IReduxAction<T, M>
    value: AxiosResponse<T>
}
export type DispatchPromise<T = any, M = any> = Promise<DispatchResponse<T, M>>
export type AxiosPromiseAction<T = any, M = any> = IReduxAction<AxiosPromise<T>, M>
export type AxiosResponseAction<T = any, M = any> = IReduxAction<AxiosResponse<T>, M>

export type Store = ReturnType<typeof rootReducer>
